import "./review_translation_controller.js"
import "./reviews_form_controller.js"
